import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { TextField, MenuItem, Autocomplete } from "@mui/material";
import { WarehouseContext } from "../../data/warehouse/WarehouseContext";
import { PersonelContext } from "../../data/personel/PersonelContext";
import CapitalizedFormikField from "../../components/CapitalizedFormikField";
import { useValidations } from "../../data/ValidationContext";

const ShelfUpdateModal = ({ isOpen, onClose, warehouseId, shelf }) => {
  const { warehouses, updateShelf } = useContext(WarehouseContext);
  const { personelList } = useContext(PersonelContext);
  const { vs_shelf } = useValidations();

  if (!shelf || !warehouseId) return null;

  const warehouse = warehouses.find((w) => w.id === warehouseId);
  if (!warehouse) return null;

  const initialValues = {
    name: shelf.name,
    status: shelf.status,
    personelId: shelf.personelId,
  };

  const statusOptions = ["Aktif", "Pasif"];

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Raf Güncelle</Modal.Title>
      </Modal.Header>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={vs_shelf} // Validation ekledik
        onSubmit={(values) => {
          // Aynı depoda isim kontrolü (mevcut raf hariç)
          if (
            warehouse.shelves.some(
              (s) => s.name === values.name && s.id !== shelf.id
            )
          ) {
            alert("Bu depoda raf adı benzersiz olmalı!");
            return;
          }

          updateShelf(warehouseId, shelf.id, {
            name: values.name,
            status: values.status,
            personelId: values.personelId,
            updatedAt: new Date(),
          });
          onClose();
        }}
      >
        {({ values, touched, errors, handleChange, setFieldValue, setFieldTouched }) => (
          <Form>
            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                {/* Raf Adı */}
                <CapitalizedFormikField
                  name="name"
                  label="Raf Adı"
                  variant="outlined"
                  size="small"
                  fullWidth
                  required
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />

                {/* Durum */}
                <CapitalizedFormikField
                  select
                  name="status"
                  label="Durum"
                  value={values.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.status && !!errors.status}
                  helperText={touched.status && errors.status}
                >
                  {statusOptions.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </CapitalizedFormikField>

                {/* Personel Seçimi */}
                <Autocomplete
                  options={personelList}
                  getOptionLabel={(option) => option.fullName}
                  value={personelList.find((p) => p.id === values.personelId) || null}
                  onChange={(e, newValue) =>
                    setFieldValue("personelId", newValue ? newValue.id : null)
                  }
                  onBlur={() => setFieldTouched("personelId", true)} // blur ile hata göster
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Personel Seç"
                      size="small"
                      fullWidth
                      error={touched.personelId && !!errors.personelId}
                      helperText={touched.personelId && errors.personelId}
                    />
                  )}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Güncelle
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ShelfUpdateModal;
